import { Component, OnInit } from '@angular/core';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { DoctorsService } from "../../services/DoctorsService";
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { DoctorssearchComponent } from '../doctorssearch/doctorssearch.component';
import Swal from 'sweetalert2';
import { DoctorFeeModel } from 'src/app/models/DoctorFeeModel';

@Component({
  selector: 'app-doctors',
  templateUrl: './doctors.component.html',
  styleUrls: ['./doctors.component.css']
})
export class DoctorsComponent implements OnInit {
  docCode = '';
  docName = '';
  docAddress = '';
  docPhone ='';
  docMobile = '';
  docmail ='';
  docDepartment = '';
  docTitle ='';
  docWPhone = '';
  docWMMobile = '';
  docWmail = '';
  docUser ='';
  compCode = '1';
  userID = 'sa';
  modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');


doccode = '' ;
patientfee = 0 ;
supervisionperc = 0 ;
chemoperc = 0 ;
radioperc = 0 ;
otherperc = 0 ;
notes = '' ;
compcode = '1' ;
userid = 'sa' ;
modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

  constructor(
              public DoctorsService: DoctorsService,
              public doctors: DoctorsModel,
              public doctorsfee :DoctorFeeModel,
              public storage: LocalStorageService,
              public doctorSelectedData: DoctorsModel,                ///----------- for searching pop up -----------
              private dialogref: MatDialog                            ///----------- for searching pop up -----------
              ) {}

  ngOnInit(): void {
    this.docCode = this.storage.retrieve('stgPatientCode');
    this.retriveDoctors();
   }

  retriveDoctors(){
    this.DoctorsService.getdoctors(this.docCode,this.storage.retrieve('stgcompCode')).subscribe((data: DoctorsModel) => {

      this.docName = data.docName;
      this.docAddress = data.docAddress;
      this.docPhone = data.docPhone;
      this.docMobile = data.docMobile;
      this.docmail = data.docmail;
      this.docDepartment = data.docDepartment;
      this.docTitle = data.docTitle;
      this.docWPhone = data.docWPhone;
      this.docWmail = data.docWmail;
      this.docWMMobile = data.docWMMobile;
      this.docUser = data.docUser;
      this.compCode = data.compCode;
      this.userID = data.userID;
      this.modifiedDate = data.modifiedDate;

    }
    );

     this.DoctorsService.getdoctorsFee(this.docCode,).subscribe((data: DoctorFeeModel) => {

      this.patientfee = data.patientfee;
      this.supervisionperc = data.supervisionperc;
      this.chemoperc = data.chemoperc;
      this.radioperc = data.radioperc;
      this.otherperc = data.otherperc;
      this.notes = data.notes;
      

    }
    );
  }
  submitDoctors() {
    this.doctors.docCode = this.docCode;
    this.doctors.docName = this.docName;
    this.doctors.docAddress = this.docAddress;
    this.doctors.docPhone = this.docPhone;
    this.doctors.docMobile = this.docMobile;
    this.doctors.docmail = this.docmail;
    this.doctors.docDepartment = this.docDepartment;
    this.doctors.docTitle = this.docTitle;
    this.doctors.docWPhone = '';
    this.doctors.docWMMobile= '';
    this.doctors.docWmail = this.docWmail;
    this.doctors.docUser = this.docUser;
    this.doctors.userID = this.storage.retrieve('stguserId');
    this.doctors.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.doctors.compCode = this.storage.retrieve('stgcompCode');

    this.DoctorsService.Adddoctors(this.doctors).subscribe(data => {
       this.submitdoctorfee();
       this.mesgSave();
       this.NewData();
    },

      error => { alert(error); }

    );

    
  }
  submitdoctorfee(){
    this.doctorsfee.doccode = this.docCode;
    this.doctorsfee.patientfee = this.patientfee ;
    this.doctorsfee.supervisionperc = this.supervisionperc ;
    this.doctorsfee.chemoperc = this.chemoperc ;
    this.doctorsfee.radioperc = this.radioperc ;
    this.doctorsfee.otherperc = this.otherperc ;
    this.doctorsfee.notes = this.notes ;
    this.doctorsfee.compcode = this.storage.retrieve('stgcompCode');
    this.doctorsfee.userid = this.storage.retrieve('stguserId');
    this.doctorsfee.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.DoctorsService.AdddoctorsFee(this.doctorsfee).subscribe(data => {
 
    },

      error => { alert(error); }

    );
  }
  NewData() {
    this.storage.store('stgPatientCode', '');
    this.docCode = '';
    this.docName = '';
    this.docAddress = '';
    this.docPhone ='';
    this.docMobile = '';
    this.docmail ='';
    this.docDepartment = '';
    this.docTitle ='';
    this.docWPhone = '';
    this.docWMMobile = '';
    this.docWmail = '';
    this.docUser ='';
    this.compCode = this.storage.retrieve('stgcompCode');
    this.userID = this.storage.retrieve('stguserId');
    this.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

    this.patientfee = 0 ;
    this.supervisionperc = 0 ;
    this.chemoperc = 0 ;
    this.radioperc = 0 ;
    this.otherperc = 0 ;
    this.notes = '' ;

  }
  deleteDoctor() {                                                   ///----------- for searching pop up -----------
      this.DoctorsService.delDoctors(this.docCode, this.storage.retrieve('stgcompCode')).subscribe(
      (data: DoctorsModel) => {
        this.docCode = data.docCode;
      

        this.compCode = data.compCode;
        this.userID = data.userID;
        this.modifiedDate = data.modifiedDate;
      }
    );
  }
  openDialog(){
    const dialogRef = this.dialogref.open(DoctorssearchComponent,
      {
        data: {
          dataKey: this.doctorSelectedData,
          type :''
        },
      width: '80%'

      });
      
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.docCode = result.docCode;
        this.docName = result.docName;
        this.docAddress = result.docAddress;
        this.docDepartment = result.docDepartment;
        this.docPhone = result.docPhone;
        this.docMobile = result.docMobile;
        this.docTitle = result.docTitle;

        this.docmail = result.docmail;
        this.docWPhone = result.docWPhone;
        this.docWMMobile = result.docWMMobile;
        this.docWmail = result.docWmail;
        this.docUser = result.docUser;

        this.compCode = result.compCode;
        this.userID = result.userID;
        this.modifiedDate = result.modifiedDate;
        this.retriveDoctors();
        dialogSubmitSubscription.unsubscribe();
      });
  }
  mesgDelete() {
    console.log('in msg delete');
    Swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(() => {
        this.deleteDoctor();
        Swal('Deleted!', 'Your record has been deleted.', 'success');

      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          Swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }

  mesgSave() {
    Swal({
    title: 'Your work has been saved',

    type: 'success',
    showConfirmButton: false,

    timer: 1500
    });
  }
}
